export default __webpack_public_path__ + "resources/icons/n440-17d9.webp";